export { selectStaticPageByAlias } from "./list/slice"
